import youtrack from './youtrack';

export default function () {
    if ($('#youtrack-section').length) youtrack();
}